/**
 * Instruments API Endpoints
 */
export const INSTRUMENTS_ENDPOINTS = {
  /**
   * Get all instruments (paginated).
   * Non-admins only see instruments they have rights to.
   * @method GET
   * @endpoint /instruments
   */
  INSTRUMENTS: "/instruments",

  /**
   * Get a single instrument by ID. Response includes location and channels[].
   * @method GET
   * @endpoint /instruments/{id}
   */
  INSTRUMENT_BY_ID: (id: number) => `/instruments/${id}`,

  /**
   * Create a new instrument. Admin only.
   * @method POST
   * @endpoint /instruments
   */
  CREATE_INSTRUMENT: "/instruments",

  /**
   * Update an existing instrument. Admin only.
   * @method PUT
   * @endpoint /instruments/{id}
   */
  UPDATE_INSTRUMENT: (id: number) => `/instruments/${id}`,

  /**
   * Delete an instrument. Admin only.
   * @method DELETE
   * @endpoint /instruments/{id}
   */
  DELETE_INSTRUMENT: (id: number) => `/instruments/${id}`,
} as const;
